import React, { useEffect, useState } from "react";
import { url } from "../../../../Constant";
import axios from "axios";
import { useAuth } from "../../../../Context/AuthProvider";
import { toast } from "react-toastify";

const BulkUploadModal = ({ closeModal, setApicalled }) => {
  const { auth } = useAuth();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const [extentionsNotBeenAdded, setExtentionsNotBeenAdded] = useState([]);
  const [bucketDetails, setBucketDetails] = useState();
  const [fileUploadError, setFileUploadError] = useState("");
  const [submittedData, setSubmittedData] = useState({
    userfile: "",
    bucket: "",
    type: "",
  });

  const getBucket = () => {
    axios
      .post(
        url + "leopard-buckets",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(function (result) {
        if (result.data.status === true) {
          setBucketDetails(result.data.data);
        }
      });
  };

  useEffect(() => {
    getBucket();
  }, []);

  const addExtension = () => {
    setLoader(true);
    setErrorEnable(true);
    var formData = new FormData();
    formData.append("vpbx_id", auth.vpbx_id);
    formData.append("file", submittedData.userfile);
    formData.append("bucket", submittedData.bucket);
    formData.append("type", submittedData.type);

    if (
      submittedData.bucket !== "" &&
      submittedData.type !== null &&
      fileUploadError === "" &&
      submittedData.userfile !== ""
    ) {
      axios
        .post(url + "leopard-buckets-upload", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code === 200) {
              setLoader(false);
              setExtentionsNotBeenAdded(response.data.data);
              // setApicalled(true);
              toast.success("Bucket added successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 30000,
              });
              // setTimeout(() => {
              //   closeModal();
              // }, 1000);
            } else {
              setLoader(false);

              // if (response.data.data.hasOwnProperty("name") === true) {
              //   response.data.data.name.map((val, index) => {
              //     return toast.error(val, {
              //       position: toast.POSITION.TOP_RIGHT,
              //       autoClose: 1500,
              //     });
              //   });
              // } else {
              //   toast.error(response?.data?.message, {
              //     position: toast.POSITION.TOP_RIGHT,
              //     autoClose: 1500,
              //   });
              // }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };

  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    // if (fileExtensionName !== "csv" || fileExtensionName !== "txt") {
    if (fileExtensionName !== "csv") {
      // setFileUploadError("Please upload csv and txt format file format only");
      setFileUploadError("Please upload csv format");
      setSubmittedData({
        ...submittedData,
        userfile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        userfile: file,
      });
    }
  };

  return (
    <div
      className="customModal ModalStyle uk-flex-top uk-open uk-flex uk-flex uk-open"
      uk-modal="esc-close: false; bg-close: false"
    >
      <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div className="filterModalContent">
          <div className="modalHeading">
            <h4>Bulk upload</h4>
          </div>
          <div className="modalForm">
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                addExtension();
              }}
            >
              <div className="uk-grid uk-grid-small" uk-grid="">
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Bucket</label>
                    <select
                      name="type"
                      value={submittedData.bucket}
                      onChange={(e) => {
                        setSubmittedData({
                          ...submittedData,
                          bucket: e.target.value,
                        });
                      }}
                      className="uk-select"
                    >
                      <option value="" selected disabled>
                        please select bucket
                      </option>
                      {bucketDetails?.bucket?.map((val, index) => {
                        return (
                          <option key={index} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>
                    {errorEnable && submittedData.bucket === "" && (
                      <div className="formErrors">Please select bucket </div>
                    )}
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Type</label>
                    <select
                      name="type"
                      value={submittedData.type}
                      onChange={(e) => {
                        setSubmittedData({
                          ...submittedData,
                          type: e.target.value,
                        });
                      }}
                      className="uk-select"
                    >
                      <option value="" selected disabled>
                        please select type
                      </option>
                      {bucketDetails?.type?.map((val, index) => {
                        return (
                          <option key={index} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>
                    {errorEnable && submittedData.type === "" && (
                      <div className="formErrors">Please select type </div>
                    )}
                  </div>
                </div>
                <div className="uk-width-1-1@m uk-margin-top">
                  <label>
                    <b>Please select any one flow extensions(file input)</b>
                  </label>
                  <br />
                  <span className="fileDisc">
                    Add flow file (only .csv format allowed)
                  </span>
                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".csv"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                    </div>
                  </div>
                  {errorEnable && submittedData.userfile === "" && (
                    <div className="formErrors">Please upload file</div>
                  )}
                  {errorEnable && fileUploadError !== "" && (
                    <div className="formErrors">{fileUploadError}</div>
                  )}
                </div>

                {extentionsNotBeenAdded.length > 0 && (
                  <div style={{ color: "red" }}>
                    Below extensions does not exist
                  </div>
                )}
                <br />
                {extentionsNotBeenAdded.length > 0 &&
                  extentionsNotBeenAdded.map((val) => {
                    return (
                      <>
                        <div style={{ fontWeight: "bold" }}>{val}</div> <br />
                      </>
                    );
                  })}

                <div className="uk-width-1-2"></div>
                <div className="uk-width-1-2">
                  <div className="btnwrp" style={{ float: "right" }}>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={() => {
                        setApicalled(true);
                        closeModal();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="Submit"
                      className="exportData-button"
                      //   onClick={() => getFilterData()}
                    >
                      {loader ? (
                        <div uk-spinner="" className="loader"></div>
                      ) : (
                        "Add"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadModal;
